import { Card, CardContent } from '@/components/ui/card';

export const TextResultPanel = ({ content }) => (
  <Card className="border-0 shadow-card rounded-card bg-white">
    <CardContent className="p-6">
      <div className="whitespace-pre-wrap text-text-primary text-sm leading-relaxed font-sans break-words">
        {content}
      </div>
    </CardContent>
  </Card>
);
